export function createMetaEventId(): string {
  return crypto.randomUUID();
}

export function isMetaTrackingEnabled(): boolean {
  return (
    import.meta.env.MODE === 'production' ||
    import.meta.env.VITE_ENABLE_TRACKER === 'true'
  );
}
